import { createMuiTheme } from '@material-ui/core/styles'


const margin = 20
const background = 'rgba(0, 0, 0, 0.8)'
const primaryColor = '#FC427B'

const primary = {
  dark: '#B33771',
  light: '#FD7272',
  main: primaryColor,
  contrastText: '#ffffff',
}

export const secondary = {
  main: '#3498db',
  dark: '#2980b9',
  light: '#0abde3',
  contrastText: '#ffffff',
}

const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
    fontFamily: [
      'Lato',
      'Cutive Mono',
    ].join(', '),
    fontSize: 12,
    htmlFontSize: 12,
    fontWeightRegular: 400,
    h1: {
      fontSize: 48,
      lineHeight: '53px',
      fontWeight: 'normal',
      fontFamily: 'Titillium Web',
    },
    h2: {
      fontSize: 36,
      lineHeight: '43px',
      fontWeight: 300,
      fontFamily: 'Titillium Web',
    },
    h3: {
      fontSize: 21,
      fontWeight: 300,
      lineHeight: '29px',
      fontFamily: 'Titillium Web',
    },
    h4: {
      fontSize: 28,
      fontWeight: 700,
      lineHeight: '36px',
      fontFamily: 'Titillium Web',
    },
    h5: {
      fontSize: 16,
      fontWeight: 400,
      fontFamily: 'Titillium Web',
    },
    h6: {
      fontWeight: 300,
      fontSize: 14,
      lineHeight: '20px',
      fontFamily: 'Titillium Web',
    },
    body2: {
      fontWeight: 400,
    },
    caption: {
      display: 'block',
    },
  },

  palette: {
    primary,
    secondary,
    type: 'light',
    gold: '#f1c40f',
    common: {
      black: '#090909',
      white: 'whitesmoke',
    },
  },

  util: {
    background,
    light: 'rgba(255, 255, 255, 0.7)',
  },

  spacing: margin,

  props: {
    MuiPopover: {
      getContentAnchorEl: undefined,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center',
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'center',
      },
    },
    MuiButton: {
      disableRipple: true,
    },
    MuiRadio: {
      color: 'primary',
    },
    MuiCheckbox: {
      color: 'primary',
    },
  },

  overrides: {
    MuiButton: {
      root: {
        textTransform: 'none',
      },
    },

    ForwardRef: {
      root: {
        width: 'auto',
      },
    },

    MuiBackdrop: {
      root: {
        backgroundColor: background,
      },
    },

    MuiFormLabel: {
      root: {
        fontSize: '0.9rem',
        textTransform: 'uppercase',
      },
    },

    MuiInputLabel: {
      outlined: {
        marginTop: 5,
      },
      filled: {
        color: 'white',
      },
    },

    MuiDialogTitle: {
      root: {
        padding: 30,
        textTransform: 'uppercase',

        '& > *': {
          fontSize: 24,
          fontWeight: 700,
          color: secondary.main,
        },
      },
    },

    MuiDialog: {
      paper: {
        border: `1px solid ${secondary.main}`,
      },
    },

    MuiDialogContent: {
      root: {
        padding: '0 60px 60px',
      },
    },

    MuiOutlinedInput: {
      root: {
        marginTop: 5,
      },
      multiline: {
        background: 'white',
      },
    },
  },
})


export default theme
